import type {
	TransportControllerGetAllSchoolTransportsQueryParams
} from '@/global/api/gen/ts/TransportDTO/TransportControllerGetAllSchoolTransports';

export const TransportKeys = {
	all: ['transports'] as const,
	bySchool: (id:number) => [...TransportKeys.all, `${id}`] as const,
	search: (params:TransportControllerGetAllSchoolTransportsQueryParams) => [...TransportKeys.all, 'search', params] as const,
	searchBySchool: (id: number, params:TransportControllerGetAllSchoolTransportsQueryParams) => [...TransportKeys.bySchool(id), ...TransportKeys.search(params)] as const,
};